import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * Team Schema
 * Represents a team entity (parent of DivisionTeam)
 */

export const TeamSchema = z.object({
  _id: objectId,
  name: z.string().default(''),
  // Refs
  organization: objectId,
  league: objectId,
  division: objectId,
  registrationTeam: objectId,
  ...timestampFields,
});

export type Team = z.infer<typeof TeamSchema>;

// Metadata for Team fields (for Mongoose refs and UI)
export const teamMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  name: { label: 'Team Name', editable: true },
  organization: { ref: 'Organization', hidden: true },
  league: { ref: 'League', label: 'League' },
  division: { ref: 'Division', label: 'Division' },
  registrationTeam: { ref: 'RegistrationTeam', label: 'Registration Team' },
  created: { hidden: true },
  updated: { hidden: true },
};
